module.exports = "<h1>\n  tikes\n</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-tickets/master-tickets.component.html
// module id = ./src/app/master/master-tickets/master-tickets.component.html
// module chunks = main